
import React from 'react'

export const speedometer = <img src={"https://etender.graysonline.com/assets/icons/speedometer-95728f43aea02149e5cc5bc37936344efa9ba3ad7c3393d4f41d8a5ed20e86b1.png"} />
export const engine = <img src="https://etender.graysonline.com/assets/icons/engine-ba349e76e17154b7610b45e20e493cb2af4aff5634cb0bdea399f54664f9d655.png"/>
export const body = <img src="https://etender.graysonline.com/assets/icons/body-aaa6e3bf4cdc4727eb369145c1a5b90ed49323a14795ecb97b71fd04300bdba2.png"/>
